import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { InvoiceSummary } from '@components';

class QuickPaySummary extends Component {
	shouldComponentUpdate({ invoice }) {
		const lastProps = this.props;

		return !isEqual(invoice, lastProps.invoice);
	}

	render() {
		const {
			invoice, timeZoneId, status, type,
		} = this.props;

		return (
			<div className="bg-white border-solid border-1 border-gray-periwinkle border-radius-4 padding-horizontal-40 padding-xs-20">
				<div className="flex flex-align-items-center flex-justify-content-space-between margin-top-30 margin-bottom-10">
					<div>
						<span className="font-size-16 font-semi-bold">Invoice Summary</span>
					</div>
					<div>
						<Choose>
							<When condition={status === 'paid'}>
								<div className="font-size-12 color-white bg-green-3 border-radius-15 width-64 padding-5 text-center">PAID</div>
							</When>
							<When condition={status === 'unpaid'}>
								<div className="font-size-12 color-white bg-red-6 border-radius-15 width-64 padding-5 text-center">UNPAID</div>
							</When>
						</Choose>
					</div>
				</div>

				<div className="separator separator-solid" />
				<div className="margin-bottom-40">
					<InvoiceSummary
						invoice={invoice}
						timeZoneId={timeZoneId}
						showHeader={false}
						showCoordinatorAvatar={false}
						showRateAndQuantityColumns={false}
						showDividers
						showOnlyTotals={type === 'bulk'}
					/>
				</div>
			</div>
		);
	}
}

QuickPaySummary.propTypes = {
	invoice    : PropTypes.object,
	status     : PropTypes.string,
	timeZoneId : PropTypes.string,
	type       : PropTypes.string,
};

QuickPaySummary.defaultProps = {
	invoice    : {},
	status     : '',
	timeZoneId : '',
	type       : '',
};

export default QuickPaySummary;
